import React from "react";
import { graphql } from "gatsby"
import qrcode from '../../assets/pro-qr-code.png'
import iphone1 from '../../assets/images/iphone-01.png'
import iphone2 from '../../assets/images/iphone-02.png'
import iphone3 from '../../assets/images/iphone-03.png'
import iphone4 from '../../assets/images/iphone-04.png'
import './Steps.scss'

export default function Steps({ title, steps, button }) {
	return(
		<div className="Steps">
			<h2>{title}</h2>
			<div className="content">
				<div className="steps">
					<ul>
						{	steps &&
							steps.map(({title, text}, index) => (
							<li key={index}>
								<p><strong>{title}</strong></p>
								<p>{text}</p>
								{
									index === 0 &&
									<>
										<img className="qr-code" width="150" height="150" src={qrcode} alt="placeholder" />
										{
											button &&
											<a href={button.url} target={button.target} className="Button primary-white"><span>{button.title}</span></a>
										}
									</>
								}
							</li>
						))
						}
					</ul>
				</div>
				<div className="iphone">
					<h3>Eksempel for iPhone brukere med Safari</h3>
					<figure>
						<img src={iphone1} alt="placeholder" />
						<figcaption>1. Trykk på delingsknappen</figcaption>
					</figure>
					<figure>
						<img src={iphone2} alt="placeholder" />
						<figcaption>2. Trykk på Legg til på Hjem-skjerm</figcaption>
					</figure>
					<figure>
						<img src={iphone3} alt="placeholder" />
						<figcaption>3. Trykk på Legg til</figcaption>
					</figure>
					<figure>
						<img src={iphone4} alt="placeholder" />
						<figcaption>4. Appen er nå lagt til på din hjem-skjerm</figcaption>
					</figure>
				</div>
			</div>
		</div>
	)
}

export const query = graphql`
	fragment Steps on WpPage_Layout_block_Layout_Steps {
		fieldGroupName
		title
		steps {
			title
			text
		}
		button {
			target
			title
			url
		}
	}
`;